import { Directive, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';

import { ScrollService } from '../../services/scroll/scroll.service';

@Directive({
    selector: '[appInview]'
})
export class InviewDirective implements OnInit, OnDestroy {

    @Input() appInview: string;

    constructor (private scroll: ScrollService, private el: ElementRef) { }

    ngOnInit () {
        // register with scroll service
        this.scroll.registerInview(this.appInview, this.el);
    }

    ngOnDestroy () {
        this.scroll.deregisterInview(this.appInview);
    }

}
